import { LOCAL_DOMAINS } from 'constants/constants'

const isLocalDomain = (): boolean => {
  return LOCAL_DOMAINS.includes(window.location.hostname)
}

export default isLocalDomain
